<template>
  <div v-if="loading == 0" style=" position: fixed; bottom: 0; z-index: 1000; left: 0; right: 0; ">
    <div class="music-canvas pt-5" style="direction: ltr;">
      <div style="background-color: #ededed;"
        class="canvas-toggler text-cetner d-flex justify-content-center position-relative">
        <button @click="toggleRadio" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
          class="offCanvas-btn d-flex align-items-center justify-content-center bg-white position-absolute top-0 start-50 translate-middle">
          <img class="chevron-up rounded-circle" src="assets/svg/chevron-up.svg" />
        </button>
        <div class="w-100 gap-2 d-flex justify-content-center align-items-center">
          <div class="play-container align-items-center d-flex gap-1" @click="play">
            <img class="play" v-if="isTimerPlaying" :src="images[1].src" />
            <img class="play" v-else :src="images[0].src" />
          </div>
          <div class="bar-container d-flex flex-column gap-2 ">
            <p class="mb-0 fw-bold fs-10 text-start">{{ currentTrack.name }}</p>
            <div class="bg-white play-bar postion-relative rounded-pill">
              <div class="filled rounded-pill" :style="{ width: barWidth }"></div>
              <div class="d-flex justify-content-between pt-1 time-player">
                <p class="passed-time">{{ currentTime }}</p>
                <p class="remaining-time">{{ duration }}</p>
              </div>
            </div>
          </div>
          <img @click="toggleRadio" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" class="music-pic"
            :src="'https://core.iran-tarabar.ir/' + currentTrack.cover" alt="" />
        </div>
      </div>
      <div class="offcanvas offcanvas-bottom" dir="ltr" tabindex="-1" id="offcanvasBottom"
        aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header d-flex justify-content-between">
          <h6 class="offcanvas-title" id="offcanvasBottomLabel fw-bold">
            {{ currentTrack.name }}
          </h6>
          <img id="toggleRadio" data-bs-dismiss="offcanvas" src="assets/svg/chevron-down.svg" alt="" />
        </div>
        <div class="offcanvas-body">
          <div id="player01" class="player">
            <div class="wrapper">
              <a>
                <img :src="'https://core.iran-tarabar.ir/' + currentTrack.cover" class="img-fluid"
                  alt="LogoMusicImage" />
              </a>
              <div class="info my-2 text-right" v-if="currentTrack">
                <p class="fw-bold mb-0">{{ currentTrack.name }}</p>
                <div class="d-flex justify-content-between">
                  <span style="color: #4d4d4d">{{ currentTrack.persianDate }}</span>
                  <span style="color: #4d4d4d">{{ currentTrack.artist }}</span>
                </div>
                <img @click="closeArchiveRadio()" data-bs-toggle="modal" data-bs-target="#ModalListview"
                  src="assets/svg/list-order.svg" alt="" />

                <!-- Modal Listview -->
                <div dir="rtl" class="modal fade modalbox" id="ModalListview" data-bs-backdrop="static" tabindex="-1"
                  role="dialog">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content mt-2">
                      <div class="modal-header">
                        <h5 class="modal-title">آرشیو رادیو ایران ترابر</h5>
                        <a id="closeArchiveRadio" href="#" data-bs-dismiss="modal">بستن</a>
                      </div>
                      <div class="modal-body p-0">

                        <ul class="listview image-listview">
                          <li class="border" v-for="(item, index) in reversedTracks" :key="index">
                            <a @click="selectPlayList(item)" class="item" data-bs-dismiss="modal">
                              <img :src="this.base_url + item.cover" alt="image" class="image">
                              <div class="in">
                                <div>
                                  {{ item.name }}
                                  <footer>{{ item.artist }}</footer>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- * Modal Listview -->
              </div>

              <div class="track-time" ref="progress">
                <div class="progress__bar" @click="clickProgress">
                  <div class="progress__current" :style="{ width: barWidth }"></div>
                </div>

                <div class="time d-flex justify-content-between">
                  <div class="last-time">{{ currentTime }}</div>
                  <div class="total-time">{{ duration }}</div>
                </div>
              </div>

              <div class="controls d-flex align-items-center justify-content-center">
                <div class="prev" @click="prevTrack">
                  <img src="assets/svg/backward-icon.svg" alt="" />
                </div>
                <img src="assets/svg/backward-15.svg" @click="handleSeconds('negative')" />
                <div class="play-container align-items-center d-flex gap-1" @click="play">
                  <img class="play" v-if="isTimerPlaying" :src="images[1].src" />
                  <img class="play" v-else :src="images[0].src" />
                </div>
                <img @click="handleSeconds('positive')" src="assets/svg/forward-15.svg" alt="" />
                <div class="next" @click="nextTrack">
                  <img src="assets/svg/forward-icon.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router';
import axios from 'axios';

export default {
  data() {
    return {
      index: 0,
      playImage: null,
      audio: null,
      circleLeft: null,
      barWidth: null,
      duration: null,
      currentTime: null,
      isTimerPlaying: false,
      base_url: 'https://core.iran-tarabar.ir/',
      loading: 1,
      images: [
        {
          id: 0,
          src: "assets/svg/play.svg",
        },
        {
          id: 1,
          src: "assets/svg/pause.svg",
        },
      ],
      tracks: [],
      currentTrack: null,
      currentTrackIndex: 0,
      transitionName: null,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  methods: {
    switchImage() {
      this.playImage = this.images[this.index];
      this.index = (this.index + 1) % this.images.length;
    },
    toggleRadio() {
      localStorage.setItem("toggleRadio", true);
      if (history.pushState) {
        var newurl = window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?toggleRadio=1";
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    closeArchiveRadio() {
      localStorage.removeItem("toggleRadio");
      localStorage.setItem("closeArchiveRadio", true);
      if (history.pushState) {
        var newurl = window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?closeArchiveRadio=1";
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    resetImage() {
      this.playImage = this.images[1];
      this.index = 1;
    },
    play() {
      if (this.audio.paused) {
        localStorage.setItem("playMusic", true);
        this.audio.play();
        this.isTimerPlaying = true;
      } else {
        localStorage.removeItem("playMusic");
        this.audio.pause();
        this.isTimerPlaying = false;
      }
      this.switchImage();
    },
    generateTime() {
      let width = (100 / this.audio.duration) * this.audio.currentTime;
      this.barWidth = width + "%";
      this.circleLeft = width + "%";
      let durmin = Math.floor(this.audio.duration / 60);
      let dursec = Math.floor(this.audio.duration - durmin * 60);
      let curmin = Math.floor(this.audio.currentTime / 60);
      let cursec = Math.floor(this.audio.currentTime - curmin * 60);
      if (durmin < 10) {
        durmin = "0" + durmin;
      }
      if (dursec < 10) {
        dursec = "0" + dursec;
      }
      if (curmin < 10) {
        curmin = "0" + curmin;
      }
      if (cursec < 10) {
        cursec = "0" + cursec;
      }
      this.duration = durmin + ":" + dursec;
      this.currentTime = curmin + ":" + cursec;
    },
    updateBar(positionMusic) {
      let progress = this.$refs.progress;
      let maxduration = this.audio.duration;
      let position = positionMusic - progress.offsetLeft;
      let percentage = (100 * position) / progress.offsetWidth;
      if (percentage > 100) {
        percentage = 100;
      }
      if (percentage < 0) {
        percentage = 0;
      }
      this.barWidth = percentage + "%";
      this.circleLeft = percentage + "%";
      this.audio.currentTime = (maxduration * percentage) / 100;
      this.audio.play();
    },
    changeBar(e) {
      let progress = this.$refs.progress;
      let maxduration = this.audio.duration;
      let position = e.pageX - progress.offsetLeft;
      let percentage = (100 * position) / progress.offsetWidth;
      if (percentage > 100) {
        percentage = 100;
      }
      if (percentage < 0) {
        percentage = 0;
      }
      this.barWidth = percentage + "%";
      this.circleLeft = percentage + "%";
      this.audio.currentTime = (maxduration * percentage) / 100;
      this.audio.play();
    },
    clickProgress(e, value) {
      // console.log(e.pageX);
      this.isTimerPlaying = true;
      this.audio.pause();
      this.updateBar(e.pageX);
    },
    handleSeconds(value) {
      if (value == 'negative') {
        this.audio.currentTime = this.audio.currentTime - 15;
        this.audio.play();
      } else {
        this.audio.currentTime = this.audio.currentTime + 15;
        this.audio.play();
      }
    },
    prevTrack() {
      this.transitionName = "scale-in";
      this.isShowCover = false;
      if (this.currentTrackIndex > 0) {
        this.currentTrackIndex--;
      } else {
        this.currentTrackIndex = this.tracks.length - 1;
      }
      this.currentTrack = this.tracks[this.currentTrackIndex];
      this.resetPlayer();
    },
    nextTrack() {
      this.transitionName = "scale-out";
      this.isShowCover = false;
      if (this.currentTrackIndex < this.tracks.length - 1) {
        this.currentTrackIndex++;
      } else {
        this.currentTrackIndex = 0;
      }
      this.currentTrack = this.tracks[this.currentTrackIndex];
      this.resetPlayer();
    },
    resetPlayer() {
      this.resetImage();
      this.barWidth = 0;
      this.circleLeft = 0;
      this.audio.currentTime = 0;
      this.audio.src = 'https://core.iran-tarabar.ir/' + this.currentTrack.source;
      setTimeout(() => {
        this.audio.play();
      }, 300);
    },
    selectPlayList(audio) {
      this.currentTrack = audio;
      this.audio.src = this.base_url + this.currentTrack.source;
      this.audio.play();
    },

    fetchMusic: function () {
      let workorder = axios.get(`https://core.iran-tarabar.ir/api/driver/radio`, this.axiosConfig)
        .then((res) => {
          // console.log(res.data);
          this.tracks = res.data;
          this.$cookies.set("radio", { data: res.data }, "1h");
          let vm = this;
          // console.log(this.tracks[0]);
          this.currentTrack = this.tracks[0];
          this.loading = 0;
          this.audio = new Audio();
          this.audio.src = 'https://core.iran-tarabar.ir/' + this.currentTrack.source;
          this.audio.ontimeupdate = function () {
            vm.generateTime();
          };
          this.audio.onloadedmetadata = function () {
            vm.generateTime();
          };
          this.audio.onended = function () {
            vm.nextTrack();
            this.isTimerPlaying = true;
          };

          // this is optional (for preload covers)
          for (let index = 0; index < this.tracks.length; index++) {
            const element = this.tracks[index];
            let link = document.createElement('link');
            link.rel = "prefetch";
            link.href = element.cover;
            link.as = "image"
            document.head.appendChild(link)
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            // Save the value of 'storage_tel'
            const tel = localStorage.getItem('tel');

            // Clear localStorage
            localStorage.clear();

            // Restore 'storage_tel'
            if (tel !== null) {
              localStorage.setItem('tel', tel);
            }

            router.push({ name: 'login' })
          }
        });
      return workorder;
    },
  },
  computed: {
    reversedTracks() {
      return this.tracks.slice().reverse();
    }
  },
  mounted() {
    this.switchImage();
    let radio = this.$cookies.get("radio")
      ? this.$cookies.get("radio")
      : { data: [] };
    if (this.$route.path === '/') {
      this.fetchMusic();
    }
  }
}
</script>
<style scoped>
.time-player {
  height: 20px;
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.canvas-toggler {
  height: 94px;
  border-radius: 50px 50px 0 0;
}

.chevron-up {
  background-color: #068b80;
}

.offCanvas-btn {
  width: 60px;
  height: 60px;
  padding: 21px;
  border: none;
  border-radius: 999px;
}

.chevron-up {
  width: 40px;
  position: absolute;
  /* background-color: white; */
}

.play {
  background-color: #068b80;
  border-radius: 999px;
  padding: 15px;
  width: 58px;
}

.play-forward {
  border-radius: 999px;
  background-color: #068b80;
  width: 30px;
  height: 30px;
  padding: 5px;
}

.play-bar {
  height: 5px;
  width: 150px;
}

.filled {
  background-color: #ee9322;
  width: 40px;
  height: 5px;
}

.music-pic {
  width: 58px;
}

.offcanvas {
  height: 100vh;
  --bs-offcanvas-height: 100vh !important;
}

.track {
  padding-top: 28px;
  position: relative;
}

.track::before {
  content: "";
  height: 6px;
  width: 100%;
  display: block;
  background: #d9d9d9;
  opacity: 0.3;
  border-radius: 10px;
  position: absolute;
}

.track::after {
  content: "";
  height: 6px;
  width: 25%;
  display: block;
  background: #ee9322;
  border-radius: 10px;
}

.list-order-icon {
  width: 20px;
}

.progress__bar {
  height: 6px;
  width: 100%;
  cursor: pointer;
  background-color: #d0d8e6;
  display: inline-block;
  border-radius: 10px;
}

.position-absolute-bottom {
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
}

.text-right {
  text-align: right;
}

.progress__current {
  height: inherit;
  width: 0%;
  background-color: #ee9322;
  border-radius: 10px;
}
</style>